import {
  Button_v2 as Button,
  Container_v2 as Container,
  Typography,
  TypographyVariantsEnum,
} from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';
import { GiftIcon } from 'src/shared';

type AdditionalCheckoutPromocodeWidgetProps = {
  onGetDiscountClick: () => void;
  discount: number;
};

const AdditionalCheckoutPromocodeWidget = ({
  onGetDiscountClick,
  discount,
}: AdditionalCheckoutPromocodeWidgetProps) => {
  const { t } = useTranslation('checkout');

  return (
    <Container>
      <div className="flex flex-col items-center justify-center h-full">
        <GiftIcon className="mb-6" />
        <div className="mb-6 flex flex-col items-center gap-2">
          <Typography variant={TypographyVariantsEnum.Title24Semi} align="center">
            {t('additional_discount_title', { discount: `${discount}%` })}
          </Typography>
          <Typography variant={TypographyVariantsEnum.Text16Regular} align="center" className="text-[#212121] max-w-xs">
            {t('additional_discount_description')}{' '}
            <b>{t('additional_discount_description_bold', { discount: `${discount}%` })}</b>
          </Typography>
        </div>

        <Button size="large" fullWidth variant="blue" onClick={onGetDiscountClick}>
          {t('additional_discount_button')}
        </Button>
      </div>
    </Container>
  );
};

export default AdditionalCheckoutPromocodeWidget;
